import type { CSSProperties, ComponentPropsWithoutRef } from 'react';
import './keyframes.css';
import { useCSSTransition } from './useCSSTransition';

type FadeProps = ComponentPropsWithoutRef<'div'> & {
   show: boolean | undefined | null;
   disableEntryAnimation?: boolean;
   disableExitAnimation?: boolean;
};

const stateStyles: Record<string, CSSProperties> = {
   hide: { opacity: 0 },
   show: { opacity: 1 },
   enter: { animation: 'ui-fade-in 250ms ease-in-out forwards' },
   exit: { animation: 'ui-fade-out 250ms ease-in-out forwards' },
};

export function Fade({
   show = false,
   disableEntryAnimation = false,
   disableExitAnimation = false,
   style,
   children,
   ...otherProps
}: FadeProps) {
   const transition = useCSSTransition({
      show,
      disableEntryAnimation,
      disableExitAnimation,
   });

   return (
      <div
         hidden={transition.state === 'hide'}
         style={{ ...style, ...stateStyles[transition.state] }}
         onAnimationEnd={transition.onAnimationEnd}
         {...otherProps}
      >
         {children}
      </div>
   );
}
